import { ApiEpBilling } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.billing.feature_product.set";

type Request = NonNullable<
  Parameters<typeof ApiEpBilling.Product.FeatureSubscription.list>[0]
>["query"];
type Response = Await<
  ReturnType<typeof ApiEpBilling.Product.FeatureSubscription.list>
>;

export const useQueryBillingFeatureProductSet = (
  params?: Request,
  options?: Omit<UseQueryOptions<Response>, "queryKey" | "queryFn">,
) =>
  useQuery<Response>(
    [KEY, params],
    () =>
      ApiEpBilling.Product.FeatureSubscription.list(
        params ? { query: params } : undefined,
      ),
    options,
  );

useQueryBillingFeatureProductSet.KEY = KEY;
